import { signal, effect } from '@preact/signals';

export type TouchMode = 'auto' | 'on' | 'off';

export interface Prefs {
  /** touch controls: follow the device, or force them on or off */
  touch: TouchMode;
  master: number;
  sfx: number;
  music: number;
  shake: boolean;
  dmgNumbers: boolean;
  names: boolean;
  autoFire: boolean;
  /** touch play attacks by itself unless the player turns it off */
  autoFireTouch: boolean;
  minimap: boolean;
  dimOthers: boolean;
}

const DEFAULTS: Prefs = { touch: 'auto', master: 0.45, sfx: 0.6, music: 0.3, shake: true, dmgNumbers: true, names: true, autoFire: false, autoFireTouch: true, minimap: true, dimOthers: true };

function load(): Prefs {
  try {
    const raw = localStorage.getItem('knight.prefs');
    if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    /* ignore */
  }
  return { ...DEFAULTS };
}

export const prefs = signal<Prefs>(load());

effect(() => {
  try {
    localStorage.setItem('knight.prefs', JSON.stringify(prefs.value));
  } catch {
    /* ignore */
  }
});

export function setPref<K extends keyof Prefs>(k: K, v: Prefs[K]): void {
  prefs.value = { ...prefs.value, [k]: v };
}
